import {Component, Input, OnInit, OnChanges, SimpleChanges} from '@angular/core';
import {SignedInContextService} from "@app/@shells/signed-in-shell/signed-in-context.service";
import {FormGroup} from "@angular/forms";
import {CheckedComponentInternal} from "@app/campaigns/campaign/@common/campaign-drafting/checked-component-internal";

@Component({
  selector: 'app-campaign-billing-name[campaignForm]',
  templateUrl: './campaign-billing-name.component.html',
  styleUrls: ['./campaign-billing-name.component.scss']
})
export class CampaignBillingNameComponent implements OnInit, OnChanges {
  @Input() campaignForm!: FormGroup;
  checked: CheckedComponentInternal;

  constructor(private signedInContextService: SignedInContextService) {
    this.checked = new CheckedComponentInternal('billingName');
  }

  ngOnInit(): void {
    this.applyComponentLogic();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['campaignForm'] && this.campaignForm) {
      this.applyComponentLogic();
    }
  }

  private applyComponentLogic(): void {
    const billingNameValue = this.campaignForm.get('billingName')?.value;
    this.checked.init(this.campaignForm);
    if (!billingNameValue) {
      this.signedInContextService.context$().subscribe(context => {
        const name = context.user.name;
        this.checked?.initChecked(name);
      });
    }
  }

  checkboxClicked(): void {
    this.checked?.checkboxClicked();
  }
}
